import { Component } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { Address, selectProfileState } from '../user-profile/user-profile.state'
import { Store } from '@ngrx/store'
import { Observable } from 'rxjs'

@Component({
  selector: 'cover-user-addresses',
  templateUrl: './user-addresses.component.html',
  styleUrls: ['./user-addresses.component.scss'],
})
export class UserAddressesComponent {
  selectedIndex: number = 0
  addresses: Observable<Address>

  constructor(private readonly dialog: MatDialog, private readonly store: Store) {
    this.addresses = store.select(selectProfileState.customerAddresses)
  }

  // deleteAddress(index: number): void {
  //   let openedDialog = this.dialog.open(DeleteAddressComponent)
  //   let subscription = openedDialog
  //     .afterClosed()
  //     .pipe(
  //       tap(test => {
  //         if (test === 'true') {
  //           this.addresses.splice(index, 1)
  //           subscription.unsubscribe()
  //         }
  //       }),
  //     )
  //     .subscribe()
  // }

  // changeDefaultAddress(index: number): void {
  //   this.selectedIndex = index
  // }
}
